import * as React from 'react';

import { Flexbox } from '../../Flexbox';
import { StandardLayoutProps } from '../../types';

export const CenteredLayout: React.FunctionComponent<StandardLayoutProps> = (props) => {
    return (
        <Flexbox
            {...props}
            sx={[
                {
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                },
                ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
            ]}
        />
    );
};
